'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _footerLocal = require('./footer.local.css');

var _footerLocal2 = _interopRequireDefault(_footerLocal);

var _ookla = require('../logo/marks/ookla.svg');

var _ookla2 = _interopRequireDefault(_ookla);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var currentYear = new Date().getFullYear();

var Footer = function Footer(_ref) {
  var className = _ref.className,
      _ref$displayLegalText = _ref.displayLegalText,
      displayLegalText = _ref$displayLegalText === undefined ? false : _ref$displayLegalText;
  return _react2.default.createElement('footer', {
    className: (0, _classnames2.default)(className, _footerLocal2.default.footer)
  }, _react2.default.createElement('div', {
    className: _footerLocal2.default.container
  }, _react2.default.createElement('div', {
    className: _footerLocal2.default.left
  }, _react2.default.createElement('ul', {
    className: _footerLocal2.default.column
  }, _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: 'https://www.ookla.com/',
    alt: 'Ookla',
    rel: 'noopener noreferrer',
    target: '_blank'
  }, '\xA9 Ookla')), _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: 'https://www.ookla.com/privacy',
    alt: 'Privacy Policy',
    rel: 'noopener noreferrer',
    target: '_blank'
  }, 'Privacy Policy')), _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: 'https://www.ookla.com/terms',
    alt: 'Terms of Use',
    rel: 'noopener noreferrer',
    target: '_blank'
  }, 'Terms of Use'))), _react2.default.createElement('ul', {
    className: _footerLocal2.default.column
  }, _react2.default.createElement('li', {
    className: _footerLocal2.default.followOokla
  }, 'Follow Ookla'), _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: 'https://twitter.com/ookla',
    alt: 'Ookla Twitter',
    rel: 'noopener noreferrer',
    target: '_blank'
  }, 'Twitter')), _react2.default.createElement('li', null, _react2.default.createElement('a', {
    href: 'https://www.facebook.com/speedtest/',
    alt: 'Speedtest on Facebook',
    rel: 'noopener noreferrer',
    target: '_blank'
  }, 'Facebook')))), _react2.default.createElement('div', {
    className: _footerLocal2.default.right
  }, _react2.default.createElement('a', {
    alt: 'Ookla',
    'aria-label': 'Ookla',
    rel: 'noopener noreferrer',
    target: '_blank',
    href: 'https://www.ookla.com/',
    className: _footerLocal2.default.ooklaLogo,
    dangerouslySetInnerHTML: {
      __html: _ookla2.default
    }
  }))), displayLegalText ? _react2.default.createElement('div', {
    className: _footerLocal2.default.container
  }, _react2.default.createElement('div', {
    className: _footerLocal2.default.legalText
  }, '\xA9 2006-' + currentYear + ' Ookla, LLC., a Ziff Davis company. All Rights Reserved. \n          Ookla\xAE, Speedtest\xAE, and Speedtest Intelligence\xAE are among the federally registered \n          trademarks of Ookla, LLC and may only be used with explicit written permission.')) : null);
};

Footer.propTypes = {
  /**
   * Class to add to footer element
   */
  className: _propTypes2.default.string,
  // Some sites already have this, so don't display this again when they update.
  displayLegalText: _propTypes2.default.bool
};
exports.default = Footer;